
import { useState } from 'react';

const testimonials = [
  {
    quote: "Working with this team transformed our online presence completely. Our website traffic increased by 300% in just three months, and we're now ranking on the first page for our key search terms.",
    name: "Sarah Mitchell",
    role: "CEO, TechStart Solutions",
    avatar: "https://public.readdy.ai/ai/img_res/eaaaf68b99412750f971dbcbcbd77ad8.jpg",
    rating: 5
  },
  {
    quote: "The attention to detail and commitment to excellence is unmatched. Our new website not only looks stunning but performs exceptionally well. Highly recommended!",
    name: "Michael Chen",
    role: "Founder, Digital Innovations",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20business%20man%20founder%20portrait%2C%20confident%20male%20entrepreneur%2C%20modern%20office%20setting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20startup%20founder%20style&width=200&height=200&seq=avatar-002&orientation=squarish",
    rating: 5
  },
  {
    quote: "From concept to launch, the process was seamless. They understood our vision and delivered beyond our expectations. Our conversion rates have doubled!",
    name: "Emily Rodriguez",
    role: "Marketing Director, GrowthCo",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20business%20woman%20marketing%20director%20portrait%2C%20confident%20female%20professional%2C%20modern%20office%20setting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20marketing%20executive%20style&width=200&height=200&seq=avatar-003&orientation=squarish",
    rating: 5
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-24 bg-[#FAFBFC]">
    </section>
  );
}
